import {
  decorate, observable, action, configure,
} from 'mobx';
import api from '../api';
import BaseStore from './BaseStore';
import utils from '../utils/commonUtil';

configure({ enforceActions: 'always' }); // strict mode always - use 'false' => '"never"', 'true' => '"observed"', '"strict"' => "'always'" instead

class CustomerStore extends BaseStore {
  constructor(props) {
    super(props);
    this.initBase(); // triggering from BaseStore
    this.init = () => {
      // specific
      this.items = [];
      // cuRd = READ helper for view
      this.listHead = [
        { name: 'id', title: 'ID', sort: false },
        { name: 'name', title: 'Name', sort: false },
        { name: 'created', title: 'Created', sort: true },
      ];
    };
    this.init();
  }

  async fetchItems() { // this method is overriden
    const itemList = await api.getCustomers();
    const itemSorted = itemList.data.sort((a, b) => {
      if (a.customerName < b.customerName) return -1;
      if (a.customerName > b.customerName) return 1;
      return 0;
    });

    itemSorted.forEach((item) => {
      this.push(this.items, {
        id: item.customerId,
        name: item.customerName,
        created: utils.formatDate(item.created),
      });
    });
  }
}
decorate(CustomerStore, {
  init: action,
  items: observable,
  listHead: observable,
});

export default new CustomerStore();
